import axiosInstance from "../../axiosInstance";
import { BROWSE_SEARCH_URL, TESTIMONIAL_RATING_URL } from "../../api";

export const browseSearch = (search) => onResponse => {
    try {
        axiosInstance.get(BROWSE_SEARCH_URL + '?search=' + search)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const gettestimonialRating = (props) => onResponse => {
    try {
        axiosInstance.get(TESTIMONIAL_RATING_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};